import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    jobseeker : {},
    pitcher_name: "",
    pitcher_email_id: "",
    audioDevice: "default",
    videoDevice: "default",
};

const jobseekerSlice = createSlice({
    name:'jobseeker',
    initialState,
    reducers : {
        setJobseeker : (state, {payload}) => {
            state.jobseeker = payload;
        },
        setPitcherName : (state, {payload}) => {
            state.pitcher_name = payload;
        },
        setPitcherEmailId: (state, {payload}) => {
            state.pitcher_email_id = payload;
        },
        setAudioDevice : (state, {payload}) => {
            state.audioDevice = payload;
        },
        setVideoDevice : (state, {payload}) => {
            state.videoDevice = payload;
        },
    }
})

export const {setJobseeker, setPitcherName, setPitcherEmailId, setAudioDevice, setVideoDevice} = jobseekerSlice.actions;

export const getJobseeker = (state) => state.jobseeker.jobseeker;
export const getPitcherName = (state) => state.jobseeker.pitcher_name;
export const getPitcherEmailId = (state) => state.jobseeker.pitcher_email_id;
export const getAudioDevice = (state) => state.jobseeker.audioDevice;
export const getVideoDevice = (state) => state.jobseeker.videoDevice;

export default jobseekerSlice.reducer;